// Add to existing error message mappings
const authErrorMessages = {
  'auth/email-already-in-use': 'An account with this email already exists.',
  'auth/invalid-email': 'Please enter a valid email address.',
  'auth/operation-not-allowed': 'This operation is not allowed.',
  'auth/weak-password': 'Please choose a stronger password.',
  'auth/user-disabled': 'This account has been disabled.',
  'auth/user-not-found': 'No account found with this email.',
  'auth/wrong-password': 'Incorrect password.',
  'auth/invalid-credential': 'Invalid login credentials.',
  'auth/too-many-requests': 'Too many attempts. Please try again later.',
  'auth/network-request-failed': 'Network error. Please check your connection.',
  'auth/popup-closed-by-user': 'Sign in was cancelled.',
  'auth/requires-recent-login': 'Please sign in again to continue.',
  'auth/email-already-exists': 'An account with this email already exists.',
  'auth/invalid-login-credentials': 'Invalid email or password.',
  'auth/missing-password': 'Please enter a password.',
  'auth/invalid-email-domain':
    'Please use an email from a supported provider (Gmail, Outlook, Live, etc).'
};

// Add allowed email domains
export const allowedEmailDomains = [
  'gmail.com',
  'outlook.com',
  'hotmail.com',
  'live.com',
  'yahoo.com',
  'icloud.com',
  'me.com',
  'msn.com',
  'aol.com'
];

// Add email validation function
export function validateEmailDomain(email) {
  const domain = email.split('@')[1]?.toLowerCase();
  if (!domain || !allowedEmailDomains.includes(domain)) {
    throw new Error('auth/invalid-email-domain');
  }
  return true;
}

export function getAuthErrorMessage(error) {
  // First check for specific Firebase error codes
  if (error?.code && authErrorMessages[error.code]) {
    return authErrorMessages[error.code];
  }

  // Then check for HTTP error status codes
  if (error?.status === 400) {
    return 'Invalid request. Please check your input.';
  }

  // Finally, use the error message or a default
  return error?.message || 'An authentication error occurred';
}

export function handleAuthError(error, toast, customMessage = '') {
  console.error('Auth Error:', error);

  const message = getAuthErrorMessage(error);

  toast({
    title: customMessage || 'Authentication Error',
    description: message,
    variant: 'destructive'
  });

  return message;
}
